module.exports = __webpack_public_path__ + "media/images/landing/laptop-c7d4f879c58ef24e74f15d2d1c02762b.png";